import MenuDrawer from './MenuDrawer';
import MenuList from './ChatMenuListContainer';

export default { Drawer: MenuDrawer, List: MenuList };
